import { PhoneNumberType } from '@vista-digital/ocapi-types/v1';
export const mapMemberFormDataToContactDetails = (memberFormData) => {
    return {
        phoneNumbers: mapPhoneNumbers(memberFormData),
        address: mapAddress(memberFormData)
    };
};
const mapPhoneNumbers = (memberFormData) => {
    const { mobileNumber, homeNumber } = memberFormData;
    const phoneNumbers = [];
    if (mobileNumber) {
        phoneNumbers.push({
            type: PhoneNumberType.Mobile,
            number: mobileNumber
        });
    }
    if (homeNumber) {
        phoneNumbers.push({
            type: PhoneNumberType.Home,
            number: homeNumber
        });
    }
    return phoneNumbers;
};
const mapAddress = (memberFormData) => {
    const { address, suburb, city, state, postCode } = memberFormData;
    const memberAddress = {
        line1: address || undefined,
        suburb: suburb || undefined,
        city: city || undefined,
        state: state || undefined,
        postCode: postCode || undefined
    };
    return Object.values(memberAddress).filter(v => v !== undefined).length > 0 ? memberAddress : undefined;
};
//# sourceMappingURL=map-member-form-data-to-contact-details.js.map